document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(".accordion-item").forEach((item) => {
        item.querySelector(".accordion-item-header").addEventListener("click", () => {
            item.classList.toggle("open");
            const minus = item.querySelector('.icon-minus');
            const plus = item.querySelector('.icon-plus');
            if(minus) item.querySelector('.icon-minus').classList.add("hidden");
            if (item.classList.contains("open")) {
                setTimeout(() => {
                    if(plus) item.querySelector('.icon-plus').classList.add("hidden");
                    if(minus) item.querySelector('.icon-minus').classList.remove("hidden");
                }, 200);
            } else {
                setTimeout(() => {
                    if(plus) item.querySelector('.icon-plus').classList.remove("hidden");
                    if(minus) item.querySelector('.icon-minus').classList.add("hidden");
                }, 200);
            }
        });
    });

    let thumbnails;

    const initializeSwiper = () => {
        thumbnails = new Swiper(".product-dropdown__thumbnails-slider", {
            slidesPerView: 4,
            spaceBetween: 2,
            direction: 'horizontal',
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                750: {
                    slidesPerView: 4,
                    spaceBetween: 6,
                },
                1024: {
                    direction: 'vertical',
                },
            }
        });
    };

    initializeSwiper();

    const updateProductContent = (data) => {
        const mainImage = document.querySelector('.product-dropdown__image');
        mainImage.src = data.mainImage;

        const thumbnailsWrapper = document.querySelector('.swiper-wrapper');
        thumbnailsWrapper.innerHTML = '';

        data.images.forEach((image, index) => {
            if (index === 0) {
                mainImage.src = image;
            }
            const slide = document.createElement('div');
            slide.className = 'swiper-slide product-dropdown__thumbnails-img';
            const img = document.createElement('img');
            img.className = 'w-full';
            img.src = image; 
            slide.appendChild(img);
            thumbnailsWrapper.appendChild(slide);

            img.addEventListener('click', (e) => {
                mainImage.src = image;
            });
        });

        thumbnails.update();

        document.querySelector('.accordion-item-header-title-select').innerText = data.title;
        document.querySelector('.product-dropdown__description-text').innerText = data.description;
        document.querySelector('.product-dropdown__price-value').innerText = data.price || '$36.00';

        updateDropdownOptions(data.variants);
    };

    const updateDropdownOptions = (variants) => {
        const optionsContainer = document.querySelector('.product-dropdown__options');
        optionsContainer.innerHTML = '';
        const discountsElem = document.querySelector('.product-dropdown__options');
        let discounts = 0;
        if(discountsElem.dataset.discounts !== "") {
            discounts =  discountsElem.dataset.discounts.split('|');
        }

        variants.forEach((variant, index) => {
            const isActive = index === 0 ? 'active' : '';
            const isChecked = index === 0 ? 'checked' : '';
            const formattedPrice = `$${(variant.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            const formattedCompareAtPrice = `$${(variant.compare_at_price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            let percentageDiscount = 0;
            if(discounts != 0){
                discounts.forEach((discount) => {
                    const discountOption = discount.split('-');
                    const discountTitle = discountOption[0].trim()
                    const priceTitle = discountOption[1].trim()
                    if (variant.title.toLowerCase() === discountTitle.toLowerCase()) {
                        percentageDiscount = priceTitle;
                    }
                });
            }

            optionsContainer.innerHTML += `
                <div class="product-dropdown__option ${isActive}">
                    <input data-variant="${variant.id}" data-compared-price="${formattedCompareAtPrice}" data-product='${JSON.stringify(variant)}' data-price="${formattedPrice}" data-discount="${percentageDiscount}" data-availability="${variant.available}" id="prod-op-${variant.title}" name="option" type="radio" value="${variant.title}" ${isChecked}> 
                    <label for="prod-op-${variant.title}">${variant.title}</label>
                </div>
            `;
        });
        addEventListenersToOptions();

        const discountElement = document.querySelector(".product-dropdown__price-discount--value");
        const currentVariant = document.querySelector('input[name="option"]:checked');
        discountElement.textContent = currentVariant.dataset.discount;
        const value = currentVariant.dataset.discount;
        if(value === '0'){
            discountElement.parentElement.classList.remove('active');
        }else{
            discountElement.parentElement.classList.add('active');
        }

        updateAddToCartButton();
    };

    const addEventListenersToOptions = () => {
        const options = document.querySelectorAll(".product-dropdown__option input[type='radio']");

        options.forEach((option) => {
            option.addEventListener("change", function () {
                removeAllActiveClasses();
                option.parentElement.classList.add('active');
                const comparedPrice = document.querySelector('.product-dropdown__price-currency');
                const discountElement = document.querySelector(".product-dropdown__price-discount--value");
                const currentVariant = document.querySelector('input[name="option"]:checked');
                const priceElement = document.querySelector(".product-dropdown__price-value");
                const value = currentVariant.dataset.discount;
                priceElement.textContent = option.dataset.price;
                if (option.dataset.comparedPrice == 0 || option.dataset.comparedPrice == '$0.00') {
                    comparedPrice.classList.add("hidden");
                } else {
                    comparedPrice.classList.remove("hidden");
                }
                comparedPrice.textContent = option.dataset.comparedPrice;
                discountElement.textContent = currentVariant.dataset.discount;
                if(value === '0'){
                    discountElement.parentElement.classList.remove('active');
                }else{
                    discountElement.parentElement.classList.add('active');
                }

                updateAddToCartButton();
            });
        });
    };

    const updateAddToCartButton = () => {
        const currentVariant = document.querySelector('input[name="option"]:checked');
        const addToCartButton = document.querySelector('#add-to-cart-button');
        const textBtn = document.querySelector('#add-to-cart-button span');

        console.log('currentVariant.dataset.stock', currentVariant.dataset);
        console.log('textBtn', textBtn);
        if (currentVariant && currentVariant.dataset.availability === 'true') {
            addToCartButton.disabled = false;
            textBtn.textContent = 'Add to Cart';
        } else {
            addToCartButton.disabled = true;
            textBtn.textContent = 'Out of Stock';
        }
    };

    document.querySelectorAll('.accordion-item-btn').forEach((button, index) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const buttonData = event.currentTarget.dataset;
            const images = JSON.parse(button.getAttribute('data-images'));

            const data = {
                images: images,
                productId: buttonData.productId,
                variantId: buttonData.variantId,
                title: buttonData.title,
                description: buttonData.description,
                price: buttonData.price,
                comparedPrice: buttonData.comparedPrice,
                details: buttonData.details,
                ingredients: buttonData.ingredients,
                nutritionText: buttonData.nutritionText,
                nutritionImg: buttonData.nutritionImg,
                variants: JSON.parse(buttonData.variant)
            };

            updateProductContent(data);
            clearAll();
            document.querySelector(`[data-accordion-prod="${buttonData.productId}"]`).classList.add('current-product');
        });

        if(index === 0) {
            const buttonData = button.dataset;
            const images = JSON.parse(button.getAttribute('data-images'));

            const data = {
                images: images,
                productId: buttonData.productId,
                variantId: buttonData.variantId,
                title: buttonData.title,
                description: buttonData.description,
                price: buttonData.price,
                comparedPrice: buttonData.comparedPrice,
                details: buttonData.details,
                ingredients: buttonData.ingredients,
                nutritionText: buttonData.nutritionText,
                nutritionImg: buttonData.nutritionImg,
                variants: JSON.parse(buttonData.variant)
            };

            updateProductContent(data);
            clearAll();
            document.querySelector(`[data-accordion-prod="${buttonData.productId}"]`).classList.add('current-product');
        }
    });

    function clearAll() {
        document.querySelectorAll('[data-accordion-prod]').forEach(item => {
            item.classList.remove('current-product');
        });
    }

    document.querySelectorAll('[data-accordion-prod]')[0].classList.add('current-product');

    function removeAllActiveClasses() {
        const options = document.querySelectorAll(".product-dropdown__option input[type='radio']");
        options.forEach((option) => {
            option.parentElement.classList.remove('active');
        });
    }

    const decrementBtn = document.querySelector('.decrement-btn');
    const incrementBtn = document.querySelector('.increment-btn');
    const quantityInput = document.querySelector('.product_dropdown-quantity input[type="number"]');

    decrementBtn.addEventListener('click', function () {
        let currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
        }
    });

    incrementBtn.addEventListener('click', function () {
        let currentValue = parseInt(quantityInput.value);
        quantityInput.value = currentValue + 1;
    });

    async function addToCart() {
        const currentVariant = document.querySelector('input[name="option"]:checked');
        const qtd = parseInt(quantityInput.value) || 1;

        const formData = new FormData();
        formData.append('id', currentVariant.dataset.variant);
        formData.append('quantity', qtd);

        const config = {
            method: 'POST',
            headers: {
                'Accept': 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        };

        fetch('/cart/add', config)
        .then(response => response.json())
        .then(response => {
            if (response.status) {
                console.error('Error (Status): ', response.status);
                return;
            }
        }).catch(e => {
            console.error('Error (Cart API): ', e);
        });
    }

    const addToCartButton = document.querySelector('#add-to-cart-button');
    addToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        addToCart();
    });

    addEventListenersToOptions();
});
